module.exports = __webpack_public_path__ + "img/Bloomberg.06b7103c.jpg";